export const defaultChartTitle = 'Insights';

export const commonChartOptions = {
  title: {
    text: defaultChartTitle
  },
  chart: {},
  lang: {
    drillUpText: '< Back to {lowerSeriesOptions.id}'
  },
  // plotOptions: {
  //   pie: {
  //     point: {
  //       events: {
  //         legendItemClick: function onClickPieLegend() {
  //           return false;
  //         },
  //       }
  //     }
  //   },
  //   series: {
  //     states: {
  //       inactive: {
  //         animation: {
  //           duration: 0
  //         }
  //       },
  //       normal: {
  //         animation: {
  //           duration: 0
  //         }
  //       }
  //     }
  //   }
  // },
  series: [],
  credits: {
    enabled: false
  },
  drilldown: {
    drillUpButton: {
      position: {
        x: 0,
        y: -10,
        align: 'left'
      }
    }
  },
  // legend: {
  //   floating: true,
  //   align: 'left',
  //   verticalAlign: 'bottom',
  //   maxHeight: 70,
  //   navigation: {
  //     activeColor: '#CCC',
  //     inactiveColor: '#3E576F',
  //     animation: false
  //   }
  // }
};